import { render, staticRenderFns } from "./IvaAplicado.vue?vue&type=template&id=64055506&"
import script from "./IvaAplicado.vue?vue&type=script&lang=js&"
export * from "./IvaAplicado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports